class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, JSON.parse(this.dataset.keys), 0, true);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {

    
    super();
    this.accordionStates = new Map(); 

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
      
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
      this.restoreAccordionStates();
       this.discountCodeApplying();

    }, 300);

    this.addEventListener('change', (ev) => {      
      const otherInputs = document.querySelectorAll('.quantity__input:not([id="' + ev.target.id + '"])');
      otherInputs.forEach(input => {
        input.disabled = 'disabled';
      });
    });
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.addEventListener('click', (event) => {
      if (event.target.classList.contains('cart-item__customiser-link') || event.target.closest('.cart-item__customiser-link')) {
        const target = (event.target.classList.contains('cart-item__customiser-link')) ? event.target : event.target.closest('.cart-item__customiser-link');
        this.loadConfigurator(target);
      }
      if (event.target.classList.contains('design-duplicate__btn')) {
        const target = (event.target.classList.contains('design-duplicate__btn')) ? event.target : event.target.closest('.design-duplicate__btn');        
        this.loadConfigurator(target, true);
      }
    }, false);
    this.init();
    this.discountCodeApplying()
    
    //Add customer id to designs
    window.IsCustomerIdUpdated = false;
    this.addCustomerId();
  }

async discountCodeApplying() {
  const discountCodeApplyBtn = document.getElementById('apply-discount');

  if (!discountCodeApplyBtn) return;

  const wrongCodeText = discountCodeApplyBtn.dataset.wrong;
  const successCodeText = discountCodeApplyBtn.dataset.success;
  const emptyCodeText = discountCodeApplyBtn.dataset.empty;

  const discountMessage = document.getElementById('discount-message');
  const spinner = document.getElementById('spinner');

  // Track non-applicable codes
  const invalidCodes = new Set();

  discountCodeApplyBtn.addEventListener('click', async () => {
    const discountCodeInput = document.getElementById('discount-code');
    const discountCode = discountCodeInput.value.trim();

    discountMessage.textContent = "";

    if (discountCode === "") {
      discountMessage.textContent = emptyCodeText;
      return;
    }

    try {
      spinner.style.display = "block";

      // STEP 1: Fetch existing cart
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      let existingCodes = (cart.discount_codes || [])
        .map(dc => dc.code)
        .filter(code => code && !invalidCodes.has(code)); // Skip previously failed codes

      if (existingCodes.includes(discountCode)) {
        discountMessage.textContent = successCodeText + " (already applied)";
      } else {
        const updatedCodes = [...existingCodes, discountCode];

        // STEP 2: Try to apply all valid + new code
        const updateRes = await fetch(`/cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ discount: updatedCodes.join(',') }),
        });

        const updateData = await updateRes.json();

        const newCodeEntry = updateData.discount_codes?.find(code => code.code === discountCode);

        if (!newCodeEntry || newCodeEntry.applicable === false) {
          discountMessage.textContent = wrongCodeText;
          invalidCodes.add(discountCode); // Mark it as invalid
        } else {
          discountMessage.textContent = successCodeText;
        }
      }

      const updatedCartRes = await fetch('/cart.js');
      const updatedCart = await updatedCartRes.json();

      const discountCodes = (updatedCart.discount_codes || []).map(dc => ({
        code: dc.code,
        applicable: dc.applicable,
      }));

      const cartLevelDiscounts = (updatedCart.cart_level_discount_applications || []).map(d => ({
        title: d.title,
        type: d.target_type,
      }));

      this.updateCartContent?.(); 
    } catch (error) {
      console.error('Discount error:', error);
      discountMessage.textContent = wrongCodeText;
    } finally {
      spinner.style.display = "none";
    }
  });
}


//Add customerId to designs
async addCustomerId() {        
  let customerId = window.customerId;    
  let visitCounter;
  
  if(customerId) {
    window.IsCustomerIdUpdated = true;
    visitCounter = localStorage.getItem('visitCounter') ? parseInt(localStorage.getItem('visitCounter')) : 0;    
  }
  
  let isCustomerIdUpdated = window.IsCustomerIdUpdated;  
   
  if(isCustomerIdUpdated && visitCounter < 1) {
    let editDesignButtons = document.querySelectorAll('.cart-items__design-id');
    
    if (editDesignButtons) {
        let designIds = [];
        const baseUrl = window.levi9BaseUrl;
        const authToken = new AuthToken();
        const accessToken = await authToken.getToken(); // Wait for the token to resolve
      
        editDesignButtons.forEach(button => {
            let designId = button.dataset?.configuratorDesignId;
            if (designId) {                
                designIds.push(designId);
            }
        });

        if (designIds.length > 0) {
            await fetch(`${baseUrl}/ProductDesigns/updateCustomerIds`, {
                method: 'PUT',
                headers: {                      
                  "Content-Type": "application/json",
                  "x-token": accessToken,
                  "x-customerId": customerId,
                },
                body: JSON.stringify({ designIds })
            })
            .then(response => response.json())
            .then(data => console.log('Success:', data))
            .catch(error => console.error('Error:', error));
      }
      visitCounter++;
      localStorage.setItem('visitCounter', visitCounter);
    }
  }
}
  
 updateCartContent() { 
  const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.renderCart(state, close);        
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
    });    
}


  
  init() {
    
    this.querySelectorAll('.quantity__input').forEach(el => {
      if (el.disabled) {
        el.disabled = false;
      }
    });
    this.openProductList();
    this.checkQuantity();      
  }

  async loadConfigurator(target, isDuplicate) {    
    // this.productConfigurator = document.querySelector('product-configurator[data-section="header"]');
    this.productConfigurator = (this.productConfigurator) ? this.productConfigurator : document.querySelector('product-configurator:not([data-section="header"])');
    const dataset = target.dataset;
    let fromCart = dataset.fromcart;
    let duplicateDesignId;

    if(isDuplicate) {      
      duplicateDesignId = await this.duplicateDesign(dataset);
      fromCart = false;
    }
    
    if(dataset.percentage) {
      this.productConfigurator.dataset.percentage = JSON.parse(dataset.percentage);
    }
    
    const premiumGraphicProduct = JSON.parse(dataset.productPremiumgraphic)
    const isFromCart = fromCart;
    const variants = JSON.parse(dataset.variants);
    const product_variants = JSON.parse(dataset.productVariants);
    const variantsStock = JSON.parse(dataset.productVariantsstock);
    const sizesTableArray = JSON.parse(dataset.productProductimagesizes);
    window.urlReplace =`${target.dataset.productUrl}&_configurator_design_id=${dataset.configuratorDesignId}`;
    const eventData = {
      bubbles: true,
      detail: {        
        productCustomTags: JSON.parse(dataset.productcustomtags),
        configuratorDesignId: isDuplicate ? duplicateDesignId : dataset.configuratorDesignId,
        variants: variants,
        printing_variants: JSON.parse(dataset.printing),
        cartTotal: JSON.parse(dataset.cartTotal),
        tags: JSON.parse(dataset.tags),
        productHandler: dataset.productHandler,
        baseShopUrl: dataset.baseShopUrl,
        route: dataset.route,
        fromCart: Boolean(isFromCart),
        product: {
          productSizeImageLink: dataset.productProductsizeimagelink,
          productImageSizes: sizesTableArray,
          productTranslation: JSON.parse(dataset.productProducttranslation),
          productColorTranslation: JSON.parse(dataset.productProductcolortranslation),
          id: dataset.productId,
          color:  dataset.color,
          quality: dataset.quality,
          variants: product_variants,
          variantsStock:variantsStock,
          premiumGraphic:premiumGraphicProduct
        }
      }
    };

    this.productConfigurator.dispatchEvent(new CustomEvent('shirtup:configure', eventData));
  }

  generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0; // Generate a random number (0-15)
      const v = c === 'x' ? r : (r & 0x3 | 0x8); // Use r for 'x' and modify for 'y'
      return v.toString(16); // Convert to hexadecimal
    });
  }

  async duplicateDesign(dataset) {      
      const designId = dataset.configuratorDesignId;
      const customerId = dataset.customer ? dataset.customer : localStorage.getItem('usersIds');
      const baseUrl = window.levi9BaseUrl;
      const authToken = new AuthToken();
      let customerIds = window.customerId;
      let isGuest = !customerIds;      
      if (designId && customerId && baseUrl) {
        const url = `${baseUrl}/ProductDesigns/${designId}/duplicate`;
  
        try {
            const accessToken = await authToken.getToken(); // Wait for the token to resolve
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-token": accessToken,
                    "x-customerId": customerId,
                },
                body: JSON.stringify({
                    id: designId,
                    customerId: customerId,
                    name: this.generateGUID(),
                    anonymous: isGuest
                }),
              });
  
              if (response.status === 200) {
                  const newId = await response.json(); // Wait for the response JSON
                  return newId; // Return the result
              } else {
                  console.error("Error duplicating design:", response);
              }
          } catch (error) {
              console.error("Error duplicating design:", error);
          }
      } else {
          console.error("Missing required data for duplication.");
      }
      return null; // Return null if something goes wrong
  }

  onChange(event) {
    if (event.target.getAttribute('form')) {
      const keys = event.target.dataset.keys ? JSON.parse(event.target.dataset.keys) : [];
      this.updateQuantity(event.target.dataset.index, keys, event.target.value, document.activeElement.getAttribute('name'), false);
    } else {
      const printIds = event.target.dataset.printIds ? JSON.parse(event.target.dataset.printIds) : [];      
      const orderDesignId = event.target.dataset.orderDesignId || "";
      const printingPrice = event.target.dataset.printingPrice;      
      this.addItem(event.target.name, printIds, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.designId, event.target.dataset.designName, event.target.dataset.smakeId, orderDesignId, printingPrice);
      this.checkQuantity();
    }
  }

  getSectionsToRender() {
    return [
       {
        id: 'main-cart-items',
        section: document.getElementById('cart-progress-wrapper').dataset.id,
        selector: '.free-shiping_bar',        
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
        
      },
           
    ];
  }

  addItem(id, printIds, quantity, name, designId, designName, smakeVariantId, orderDesignId, printingPrice) {
      this.saveAccordionStates();
      let formData = {
        items: [
          {
            id: id,
            quantity: quantity,
            properties: {
              '_designName': designName,
              '_type': 'configurator_product',
              '_configurator_design_id': designId,
              '_smake_variant_id': smakeVariantId,
              '_order_design_id': orderDesignId,
              '_for_line_item_id': id,
              '_print_price': printingPrice,
              '_print_positions': printIds.toString()
            }
          }
        ],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
   
      const body = JSON.stringify(formData);
          fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.errors || 'An error occurred while adding the item to the cart.');
          });
        }
          return response.text();
      })
        .then((state) => {
          this.renderCart(state, false);
        }).catch((error) => {
          if(error){
            // this.showModal(error.message);
            console.log(error)
          }
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
          this.disableLoading();
          
        });
  }
  
  showModal(title) {
    // Create the modal HTML structure
    const modalHTML = `
      <popup-modal class="popup-modal">
        <button class="button link-text">
        </button>
        <dialog>
          <form method="dialog">
            <header>
              <button value="cancel" class="text_link link">
                <svg class="icon icon-close"><use href="#icon-close"></use></svg>
              </button>
            </header>
            <div class="rte">
              ${title}
            </div>
          </form>
        </dialog>
      </popup-modal>
      <style>
        dialog {
          display: none;
        }
        dialog[open] {
          display: block;
        }
        .modal-open {
          display: block;
        }
        .icon-close {
          cursor: pointer;
        }
      </style>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const modal = document.querySelector(".popup-modal dialog");
    const closeBtn = modal.querySelector("button[value='cancel']");

    modal.showModal();

    closeBtn.onclick = function(event) {
      event.preventDefault();
      modal.close();
      modal.parentElement.remove(); 
      location.reload();
    }

    window.onclick = function(event) {
      if (event.target == modal) {
        modal.close();
        modal.parentElement.remove();
        location.reload();
      }
    }
  }
  renderCart(state, close) {
    const openDialog = this.querySelector('.cart-item__quantity dialog[open]');
    const parsedState = JSON.parse(state);
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    let cartBubble = document.querySelector('.cart-count-bubble');
    if (cartBubble) cartBubble.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      this.init();
    }));
    this.disableLoading();
    this.restoreAccordionStates();
    //  if (close == false) {
    //   document.getElementById(openDialog.id).showModal();
    // }
    this.checkQuantity();
    // if (line && name) {
    //   this.updateLiveRegions(line, parsedState.item_count);
    //   const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    //   if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
    //     cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
    //   } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
    //     trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
    //   } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
    //     trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
    //   }
    // }
    
  }  
  
  updateQuantity(line, keys, quantity, name, close) {
    this.saveAccordionStates();
    this.enableLoading(line);
    let updates = {};
    keys.forEach(key => {
      updates[key] = quantity;
    });
    const body = JSON.stringify({
      updates: updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.renderCart(state, close);
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });    
  }
  
  checkQuantity(){
  var inputElements = document.getElementsByClassName("quantity__input");
  if(inputElements){
  Array.from(inputElements).forEach(input=>{
  input.addEventListener('change', function() {
  const maxLimit = parseInt(input.getAttribute('data-number'));
  const value = parseInt(input.value);
  var outOfStockField = document.getElementById("out-of-stock-message");
  if (value > maxLimit) {
    input.value = maxLimit; // Set the value to the max limit
    outOfStockField.style.display = 'block';
  }
  else{
    outOfStockField.style.display = "none";
  }
  })
  });
  }
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  openProductList() {
    const size_dropdowns = document.querySelectorAll('.sizes-picker__dropdown');

    document.querySelectorAll('.cart-accordion-button').forEach(function(button) {
        button.addEventListener('click', function(event) {
            // Stop the event from bubbling up to the document
            event.stopPropagation();
    
            var contentSelector = this.getAttribute('data-target');
            var content = document.querySelector(contentSelector);
            var svg = this.querySelector('svg'); 
            
            // Hide all size dropdowns first
            size_dropdowns.forEach(function(dropdown) {
                if(dropdown != content)
                dropdown.removeAttribute('open');
                dropdown.style.display = "none";
                const svg = dropdown.previousElementSibling.querySelector('svg');
                if (svg) svg.classList.remove('rotate');
            });
                
            if (content.getAttribute('open') == null) {
                content.setAttribute('open', ''); 
                content.style.display = "block";
                svg.classList.add('rotate');
            } else {
                content.removeAttribute('open');
                content.style.display = "none";
                svg.classList.remove('rotate');
            }
        });
    });

    // Collapse dropdowns with the same toggle behavior when clicking outside
    document.addEventListener('click', function(event) {
        size_dropdowns.forEach(function(dropdown) {
            // Check if the click is outside both the dropdowns and the cart-accordion buttons
            if (!event.target.closest('.sizes-picker__dropdown') && !event.target.closest('.cart-accordion-button')) {
                const relatedButton = document.querySelector(`[data-target="#${dropdown.id}"]`);
                const svg = relatedButton ? relatedButton.querySelector('svg') : null;
                
                if (dropdown.getAttribute('open') !== null) {
                    // Collapse dropdown
                    dropdown.removeAttribute('open');
                    dropdown.style.display = "none";
                    if (svg) svg.classList.remove('rotate');
                }
            }
        });
    });
  }

  saveAccordionStates() {
    document.querySelectorAll('.cart-accordion-button').forEach(button => {
      const contentSelector = button.getAttribute('data-target');
      const isOpen = document.querySelector(contentSelector).hasAttribute('open');
      this.accordionStates.set(contentSelector, isOpen);
    });
  }
  restoreAccordionStates() {
  this.accordionStates.forEach((isOpen, contentSelector) => {
    const content = document.querySelector(contentSelector);
    if (!content) return; 

    const button = document.querySelector(`[data-target="${contentSelector}"]`);
    const svg = button.querySelector('svg');

    if (isOpen) {
      content.setAttribute('open', '');
      content.style.display = "block";
      svg.classList.add('rotate');
    } else {
      content.removeAttribute('open');
      content.style.display = "none";
      svg.classList.remove('rotate');
    }
  });
}
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    // document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
      
    }
  });
};

